<template>
    <div @click="isOpen = true" class="md:hidden cursor-pointer p-2">
        <ion-icon name="menu-outline" class="text-[24px]"></ion-icon>
    </div>
    <Teleport to="body">
        <Transition name="fade">
            <div
                v-if="isOpen"
                class="
                    fixed
                    top-0
                    left-0
                    w-full
                    h-full
                    bg-black bg-opacity-50
                    z-[101]
                    flex
                    items-start
                "
            >
                <section
                    :class="[
                        `w-[300px] bg-white h-full h-[100vh] flex flex-col duration-100 text-xs md:hidden`,
                    ]"
                    id="mobile-app-sidebar"
                >
                    <img
                        src="/img/clipboard logo.jpg"
                        alt="Clipboard Nation Logo"
                        class="
                            w-[35%]
                            h-auto
                            mx-auto
                            mt-4
                            border-b-2
                            pb-6
                            border-gray-100
                        "
                    />
                    <slot class="my-8"></slot>
                </section>
                <button
                    @click="isOpen = false"
                    class="ml-4 mt-4 text-white text-xl"
                >
                    <ion-icon name="close"></ion-icon>
                </button>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
export default {
    name: "MobileAppSidebarGuest",
    props: ["defaultCollapsed"],
    watch: {},
    mounted() {
        if (window.ReactNativeWebView) {
            window.handleHideSidebar = () => {
                this.isOpen = false;
            };
        }
    },
    data() {
        return {
            isOpen: false,
        };
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
</style>
